import React from "react";

export const Checked = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <g clipPath="url(#clip0_11_250)">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4 0C1.79086 0 0 1.79086 0 4V12C0 14.2091 1.79086 16 4 16H12C14.2091 16 16 14.2091 16 12V4.62133L8 12.6213L2.93934 7.56067L5.06066 5.43935L8 8.37869L15.0115 1.36722C14.2783 0.529244 13.2009 0 12 0H4Z"
                    fill="white"
                />
            </g>
            <defs>
                <clipPath id="clip0_11_250">
                    <rect width="16" height="16" rx="4" fill="white"/>
                </clipPath>
            </defs>
        </svg>
    )
}
